import { useRouter } from 'next/router';

export const useExtractLanguageFromUrl = () => {
  const router = useRouter();
  const urlSegments = router.asPath.split('/');
  const language = urlSegments.length > 1 ? urlSegments[1] : 'en';

  return language;
};
